import { useQuery } from '@tanstack/react-query';
import { analyticsGetBranchReport } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useBranchReport = (year: number, month: number) =>
  useQuery({
    queryFn: async () => {
      return extractData(analyticsGetBranchReport({ path: { year, month } }));
    },
    queryKey: ['branchReports', year, month],
  });
